// extracted by mini-css-extract-plugin
export default {"CardTitle":"Card_CardTitle__dK7wW","Card":"Card_Card__Clkiv","CardImage":"Card_CardImage__OQU-n","CardActive":"Card_CardActive__UUs11"};